var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-filters"},[_c('div',{staticClass:"dashboard-filters__item"},[_c('Select2',{attrs:{"options":['Partner 1','Partner 2'],"settings":{
                placeholder: 'Service'
            }},on:{"change":_vm.filter}})],1),_c('div',{staticClass:"dashboard-filters__item"},[_c('Select2',{attrs:{"options":['Partner 1','Partner 2'],"settings":{
                placeholder: 'Month'
            }},on:{"change":_vm.filter}})],1),_c('div',{staticClass:"dashboard-filters__item"},[_c('Select2',{attrs:{"options":['Partner 1','Partner 2'],"settings":{
                placeholder: 'Partners'
            }},on:{"change":_vm.filter}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }